import {connect} from 'react-redux'
import {setEmail, setName, setPhone} from '../actions';
import Registration from '../components/Registration';

const mapStateToProps = (state) => ({
    name:  state.tours.registration.name,
    phone: state.tours.registration.phone,
    email: state.tours.registration.email
});

const mapDispatchToProps = (dispatch) => ({
    setName:  (name) => dispatch(setName(name)),
    setPhone: (phone) => dispatch(setPhone(phone)),
    setEmail: (email) => dispatch(setEmail(email))
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Registration);



// WEBPACK FOOTER //
// ./src/app/tours/containers/Registration.js